"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Challenge = void 0;
var title_case_1 = require("../../utils/title-case");
var create_entity_1 = require("../../utils/create-entity");
var challenge_card_1 = require("../../components/entities/challenge-card");
var challenge_details_banner_1 = require("../../components/entities/challenge-details-banner");
var challenge_details_layout_1 = require("../../components/entities/challenge-details-layout");
var lodash_1 = require("lodash");
var entity_select_transform_1 = require("../../utils/entity-select-transform");
var graphql_1 = require("../../utils/graphql");
// ----
exports.Challenge = {
  name: 'Challenge',
  label: 'Grand Challenge',
  pluralLabel: 'Grand Challenges',
  groupName: process.env.TAXONOMIES_LABEL || "Challenges & Goals",
  isPublic: true,
  slug: 'grand-challenge',
  usePublishStatus: true,
  useConversation: true,
  useSlices: true,
  useSpaces: true,
  useFollowers: true,
  includeInSearch: true,
  useSiteSlug: true,
  useModerators: true,
  useConnections: true,
  usePermissions: true,
  // useNetwork: true,
  canEmbed: true,
  network: {
    velocityDecay: 0.4
  },
  select: {
    transform: function (entity, context) {
      var _a, _b;
      return __assign(__assign({}, (0, entity_select_transform_1.entitySelectTransform)(entity, context)), {
        icon: context.icons.Challenge[(0, title_case_1.titleCase)(entity.slug)],
        color: ((_a = context.theme.light) === null || _a === void 0 ? void 0 : _a.color.challenge) && ((_b = context.theme.light) === null || _b === void 0 ? void 0 : _b.color.challenge[(0, lodash_1.camelCase)(entity.slug)])
      });
    },
    canCreate: function () {
      return false;
    },
    queryFields: ""
  },
  autoRoutes: ['details', 'list', 'update', 'create'],
  components: {
    card: challenge_card_1.ChallengeCard,
    details: challenge_details_layout_1.ChallengeDetailsLayout,
    banner: challenge_details_banner_1.ChallengeDetailsBanner
  },
  platformActivity: {
    tab: 'own'
  },
  form: {
    paginate: true,
    modal: {
      fill: true
    },
    fieldSets: [{
      name: "overview"
    }, {
      name: "images"
    }, {
      name: "topics"
    }, {
      name: "community"
    }, {
      name: "data"
    }, {
      name: "properties"
    }],
    fields: __assign(__assign({}, create_entity_1.entityStandardFormFields), {
      banner: {
        type: 'banner'
      },
      description: {
        type: 'description',
        useCompletions: true
      },
      dataSetId: {
        type: 'text',
        recommended: false,
        description: "Specify an ID to uniquely identify this {{CHALLENGE}}. This might be useful to tie this {{CHALLENGE}} to values coming from an external API, for example",
        monospace: true
      },
      curator: {
        label: 'Curator',
        type: 'linked',
        description: 'Who is the curator of content around this {{Challenge.label}}?',
        entityTypeName: 'Person'
      },
      keyIssues: {
        type: 'linkedMultiple',
        entityTypeName: 'KeyIssue',
        fieldSet: 'topics'
      },
      icons: {
        type: 'linkedMultiple',
        entityTypeName: 'Icon',
        description: 'Select one or more {{ICONS}} to represent this {{CHALLENGE}}'
      },
      banners: {
        type: 'linkedMultiple',
        entityTypeName: 'Banner',
        description: "Does this {{CHALLENGE}} have any other {{BANNERS}}? This is useful for assigning {{BANNERS}} for different {{SITES}}"
      },
      backgroundImages: {
        type: 'linkedMultiple',
        entityTypeName: 'ImageAsset',
        label: 'Background Images',
        description: "Does this {{CHALLENGE}} have any background images?"
      },
      colors: {
        type: 'linkedMultiple',
        entityTypeName: 'Color',
        description: "Does this {{CHALLENGE}} have any associated {{COLORS}}?"
      },
      sdgs: {
        type: 'linkedMultiple',
        entityTypeName: 'Sdg',
        fieldSet: 'topics'
      },
      links: {
        type: 'linkedMultiple',
        fieldSet: 'overview',
        entityTypeName: 'Link'
      },
      indicatorResults: {
        type: 'linkedTable',
        entityTypeName: 'IndicatorResult',
        fieldSet: 'data'
      }
    }),
    reverseFields: {
      expertise: {
        type: 'linkedMultiple',
        label: 'Add {{CHALLENGE_EXPERTISE}}',
        entityTypeName: 'ChallengeExpertise',
        source: 'challenges',
        reverseEntityTypeName: 'Person',
        reverseEntityFieldName: 'challengeExpertise'
      }
    }
  },
  list: {
    hasFilters: false,
    banner: {
      content: 'Explore our {{CHALLENGE}} Collectives'
    },
    queryFields: (0, graphql_1.graphql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      banner { id name image { id url } slug title description { id text } alternateText openGraph { id image { id url } } }\n      description { id text html }\n      people { id }\n      feedEntries { id }\n      sdgs { id }\n      organisations { id }\n      curator { ...EntityValueFields }\n      keyIssues {\n        id\n        slug\n        name\n      }\n    "], ["\n      banner { id name image { id url } slug title description { id text } alternateText openGraph { id image { id url } } }\n      description { id text html }\n      people { id }\n      feedEntries { id }\n      sdgs { id }\n      organisations { id }\n      curator { ...EntityValueFields }\n      keyIssues {\n        id\n        slug\n        name\n      }\n    "])))
  },
  details: {
    queryFields: (0, graphql_1.graphql)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      id\n      name\n      slug\n      sid\n      description {\n        id\n        text\n        html\n      }\n      sdgs { id }\n      curator { ...EntityValueFields }\n      indicators {\n        id\n        name\n        title\n        slug\n      }\n      \n      targets { ...EntityValueFields title }\n      dataSets {\n        ...EntityValueFields\n        links { id name label url }\n      }\n      keyIssues {\n        id\n        slug\n        name\n        sid\n        description {\n          id\n          html\n        }\n        influencingFactorsOutgoing {\n          id\n          sid\n          slug\n          name\n        }\n        influencingFactorsIncoming {\n          id\n          sid\n          slug\n          name\n        }\n      }\n      expertise {\n        levelOfExpertise { ...EntityValueFields orderNumber description { id text } }\n        person { ...EntityValueFields }\n      }\n      events { ...EntityValueFields }\n      sessions { ...EntityValueFields }\n      chapters { ...EntityValueFields }\n      posts { ...EntityValueFields }\n      pages { ...EntityValueFields }\n      courses { ...EntityValueFields }\n      lessons { ...EntityValueFields }\n      teams { ...EntityValueFields }\n      economies { ...EntityValueFields }\n      locations { ...EntityValueFields }\n      feeds { ...EntityValueFields }\n      videos { url ...EntityValueFields }\n      banner { id name slug title description { text } alternateText openGraph { id image { id url } } }\n      feedEntries {\n        ...EntityValueFields\n        url\n        created\n        challenge {\n          id\n          name\n          slug\n        }\n        updated\n        author\n        summary { id text }\n        image {\n          id\n          url\n          width\n          height\n          aspectRatio\n        }\n      }\n      organisations {\n        id\n        slug\n        name\n        updated\n        description { id text }\n        location { id name slug state { id name abbr } openGraph { id image { id url } } country { id name slug shorthand } }\n        industries { id slug name }\n        type { id slug name }\n        logo { id url thumbnails { id full { url width height } } }\n      }\n    "], ["\n      id\n      name\n      slug\n      sid\n      description {\n        id\n        text\n        html\n      }\n      sdgs { id }\n      curator { ...EntityValueFields }\n      indicators {\n        id\n        name\n        title\n        slug\n      }\n      \n      targets { ...EntityValueFields title }\n      dataSets {\n        ...EntityValueFields\n        links { id name label url }\n      }\n      keyIssues {\n        id\n        slug\n        name\n        sid\n        description {\n          id\n          html\n        }\n        influencingFactorsOutgoing {\n          id\n          sid\n          slug\n          name\n        }\n        influencingFactorsIncoming {\n          id\n          sid\n          slug\n          name\n        }\n      }\n      expertise {\n        levelOfExpertise { ...EntityValueFields orderNumber description { id text } }\n        person { ...EntityValueFields }\n      }\n      events { ...EntityValueFields }\n      sessions { ...EntityValueFields }\n      chapters { ...EntityValueFields }\n      posts { ...EntityValueFields }\n      pages { ...EntityValueFields }\n      courses { ...EntityValueFields }\n      lessons { ...EntityValueFields }\n      teams { ...EntityValueFields }\n      economies { ...EntityValueFields }\n      locations { ...EntityValueFields }\n      feeds { ...EntityValueFields }\n      videos { url ...EntityValueFields }\n      banner { id name slug title description { text } alternateText openGraph { id image { id url } } }\n      feedEntries {\n        ...EntityValueFields\n        url\n        created\n        challenge {\n          id\n          name\n          slug\n        }\n        updated\n        author\n        summary { id text }\n        image {\n          id\n          url\n          width\n          height\n          aspectRatio\n        }\n      }\n      organisations {\n        id\n        slug\n        name\n        updated\n        description { id text }\n        location { id name slug state { id name abbr } openGraph { id image { id url } } country { id name slug shorthand } }\n        industries { id slug name }\n        type { id slug name }\n        logo { id url thumbnails { id full { url width height } } }\n      }\n    "])))
  }
};
var templateObject_1, templateObject_2;